import "./BenefitsPartnersSection.scss"

import { FC } from "react"

import BackgroundImage from "src/assets/images/backgrounds/peoplevine-rsvp-bg-partner-green.png"
import { ContentProps, useContent } from "../../../components/App/Content"

export const BenefitsPartnersSection: FC = () => {
  const content = useContent("rsvp-key-benefits-for-partners")

  return (
    <section className='team-members' style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className='container'>
        <div className='team-members__wrapper'>
          <h2 className='team-members__title section-main-title'>{content?.title}</h2>
          <p className='team-members__text' />
          {content?.cards && (
            <div className='team-members-list'>
              {content?.cards.map(member => (
                <article key={member?.title} className='team-members-list-item'>
                  <div className='team-members-list-item__content'>
                    <h5 className='team-members-list-item__title section-secondary-title'><img src={member?.media?.url} alt={''} className='team-members-list-item__image' />{member?.title}</h5>
                    
                    <p className='team-members-list-item__position section-secondary-title'>{member?.subTitle}</p>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
